<script lang="ts">
  import {
    buttonStyle,
    endEvent,
    gameMute,
  } from './../stores'; /* Load Global Data */
  export let orientation, defaultstyle;

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let i_size = '30px'; /* Icons Size */
  let showModal = false;

  function quit() {
    showModal = false;
    endEvent.subscribe((message) => {
      console.log('ending party with  message', message);
      window.parent.postMessage(message, '*');
    })();
  }

  function toggleMute() {
    $gameMute = !$gameMute;
  }

  function resetGame() {
    dispatch('reset');
    showModal = false;
  }
</script>

<div
  class="recess {orientation} {defaultstyle
    ? 'shadow'
    : 'glass'} recess-{$buttonStyle}"
>
  <button
    on:click|preventDefault={() => (showModal = true)}
    class="button button-{$buttonStyle}"
    id="button_style"
  >
    <svg width={i_size} height={i_size} class="label label-{$buttonStyle}">
      <image
        xlink:href="icons/icon-settings.svg"
        src="icons/icon-settings.png"
        width={i_size}
        height={i_size}
      />
    </svg>
  </button>
</div>

{#if showModal}
  <div class="modal-wrapper">
    <div class="modal-inner-wrapper">
      <div class="title">Menu</div>

      <!-- <div class="row" on:click={resetGame}>
        <div class="reset">RESET</div>
        <div class="icon">
          <svg width={i_size} height={i_size} class="restart icon">
            <image
              xlink:href="icons/icon-reset.svg"
              src="icons/icon-reset.png"
              width={i_size}
              height={i_size}
            />
          </svg>
        </div>
      </div> -->

      <div class="row" on:click={toggleMute}>
        <div class="mute">SOUND {$gameMute ? 'OFF' : 'ON'}</div>
        <div class="icon">
          <svg width={i_size} height={i_size} class="volume mute icon">
            {#if $gameMute}
              <image
                xlink:href="icons/icon-mute.svg"
                src="icons/icon-mute.png"
                width={i_size}
                height={i_size}
              />
            {:else}
              <image
                xlink:href="icons/icon-volume.svg"
                src="icons/icon-volume.png"
                width={i_size}
                height={i_size}
              />
            {/if}
          </svg>
        </div>
      </div>

      <div class="row" on:click={quit} style="margin-top:20px;">
        <div class="reset">QUIT GAME</div>
        <div class="icon">
          <svg width={i_size} height={i_size} class="restart icon">
            <image
              xlink:href="icons/icon-reset.svg"
              src="icons/icon-reset.png"
              width={i_size}
              height={i_size}
            />
          </svg>
        </div>
      </div>


      <div class="buttons-wrapper mt4">
        <!-- <div on:click={quit}>QUIT</div> -->
        <div on:click={() => (showModal = false)}>CLOSE</div>
      </div>
    </div>
  </div>
{/if}

<style>
  #button_style {
    /* border: 1px solid red; */
    /* float: left; */
    /* left:0; */
  }
  /* Default button styles*/
  .recess,
  .button,
  .label {
    transition: all 0.2s;
  }
  .button:active {
    background-color: #fff !important;
  }
  /* Default styles */
  .label {
    font-size: 1.3rem;
    font-weight: 700;
    margin-top: 0%;
    color: rgba(0, 0, 0, 0.3);
  }
  .recess {
    /* border: 1px solid green; */
    /* position: relative; */
    /* width: 105px; */
  }
  .button {
    position: relative;
    float: left;
    padding: 0 !important;
    margin: 0 !important;
  }
  /* Default theme */
  .recess-default {
    box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
  }
  .button-default {
    background-color: rgba(0, 0, 0, 0.1);
    border: 1.5px solid rgba(255, 255, 255, 1);
  }
  .button-default svg.label {
    color: rgba(255, 255, 255, 0.75);
  }

  /* Xbox Theme: {buttonStlye} value toggles between "default", "mtn" and "colour" */
  .recess-colour {
    background-color: rgba(0, 0, 0, 0);
    /* background: linear-gradient(0deg, rgba(255,255,255,0.2) 0%, rgba(0,0,0,0.2) 100%); */
    box-shadow: none !important;
  }
  .button-colour {
    background-color: #3cdb4e; /* Xbox Green */
    background: linear-gradient(
      0deg,
      rgba(155, 155, 155, 1) 0%,
      rgba(200, 200, 200, 1) 40%,
      rgba(200, 200, 200, 1) 60%,
      rgba(255, 255, 255, 1) 100%
    );
    box-shadow: inset 0 -4px 0px rgb(0 0 0 / 30%);
  }
  .label-colour {
    margin-top: -5%;
    filter: invert(100);
    opacity: 0.3;
  }
  .button-colour:active {
    box-shadow: inset 0 -1px 0px rgb(0 0 0 / 30%) !important;
  }
  .button-colour:active .label-colour {
    margin-top: 0%;
  }

  /* MTN Theme: {buttonStlye} value toggles between "default" and "mtn" */
  .recess-mtn {
    background-color: rgba(0, 0, 0, 0.75);
    box-shadow: none !important;
  }
  .button-mtn {
    background-color: #ffc107; /* MTN Yellow */
    box-shadow: none !important;
  }
  .label-mtn {
    margin-top: 5%;
    filter: invert(100);
  }

  /* Orientations */
  .T {
    top: 0;
  }
  .B {
    bottom: 0;
  }
  .L {
    left: 0;
  }
  .R {
    right: 0;
  }

  .TM {
    top: 10%;
  }
  .BM {
    bottom: 10%;
  }
  .LM {
    left: 10%;
  }
  .RM {
    right: 10%;
  }

  /* MODAL */
  .modal-wrapper {
    /* border: 1px solid blue; */
    background-color: rgba(0, 0, 0, 0.75);
    align-items: center;
    display: flex;
    justify-content: center;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 0;
  }
  .modal-inner-wrapper {
    align-items: center;
    background-color: #ffc107; /* MTN Yellow */
    border-radius: 5px;
    color: black;
    display: flex;
    flex-direction: column;
    height: 60%;
    justify-content: center;
    width: 20rem;
    z-index: 4000;
    padding: 20px;
  }

  .title {
    /* border: 1px solid red; */
    font-size: x-large;
    font-weight: bold;
    margin: 2rem;
  }

  .row {
    /* border: 1px solid red; */
    align-items: center;
    display: flex;
    justify-content: space-between;
    /* margin-top: 1.5rem; */
    width: 70%;
  }

  .icon image {
    filter: invert(100);
  }

  .buttons-wrapper {
    /* border: 1px solid red; */
    display: flex;
    font-weight: bold;
    justify-content: space-evenly;
    margin: 2rem;
  }
  .buttons-wrapper div {
    background-color: #000;
    text-transform: uppercase;
    border-radius: 30px;
    padding: 5px 20px;
    margin: auto 10px;
    color: #fff;
    cursor: pointer;
  }
</style>
